var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.account.role != "admin" &&
    _vm.$route.name == "chatting" &&
    !_vm.isMobile &&
    !_vm.$vuetify.breakpoint.xsOnly
    ? _c(
        "v-menu",
        { attrs: { bottom: "", left: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: {
                slot: "activator",
                icon: "",
                dark:
                  _vm.$store.state._User.connexionType == "freshdesk"
                    ? false
                    : true
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v(_vm._s(_vm.changeView.icone))])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list",
            _vm._l(_vm.vuePupitre, function(vuePupitre, i) {
              return _c(
                "v-list-tile",
                {
                  key: i,
                  on: {
                    click: function($event) {
                      return _vm.changeViewPupitre(vuePupitre.value)
                    }
                  }
                },
                [_c("v-icon", [_vm._v(_vm._s(vuePupitre.icone))])],
                1
              )
            }),
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b2b5af7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b2b5af7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzPupitreStatus.vue
// module id = null
// module chunks = 